import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import SelectWithClear from "Components/UI/Form/SelectWithClear";

export default function StandardTerms({
  client,
  handleInputChange,
  agreementOptions,
  boolOptions,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="LatePaymentInterestPercentage"
          label="Dröjsmålsränta %"
          value={client?.LatePaymentInterestPercentage}
          onChange={(e) =>
            handleInputChange("LatePaymentInterestPercentage", e.target.value)
          }
          type="number"
          size="small"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
          <InputLabel>Referensränta adderas</InputLabel>
          <Select
            name="AddReferencePercentage"
            value={client.AddReferencePercentage}
            onChange={(e) =>
              handleInputChange("AddReferencePercentage", e.target.value)
            }
            label="Referensränta adderas"
            size="small"
            disabled
          >
            {boolOptions.map((type) => (
              <MenuItem key={type.Value} value={type.Value}>
                {type.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="OriginalFfd"
          label="FFD dagar"
          value={client?.OriginalFfd}
          onChange={(e) => handleInputChange("OriginalFfd", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm1WaitCreate"
          label="PM1 skapas efter dagar"
          value={client.Pm1WaitCreate}
          onChange={(e) => handleInputChange("Pm1WaitCreate", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm1Ffd"
          label="PM1 FFD dagar"
          value={client.Pm1Ffd}
          onChange={(e) => handleInputChange("Pm1Ffd", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm1Fee"
          label="PM1 Avgift SEK"
          value={client.Pm1Fee}
          onChange={(e) => handleInputChange("Pm1Fee", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm2WaitCreate"
          label="PM2 Skapas efter dagar"
          value={client.Pm2WaitCreate}
          onChange={(e) => handleInputChange("Pm2WaitCreate", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm2Ffd"
          label="PM2 FFD dagar"
          value={client.Pm2Ffd}
          onChange={(e) => handleInputChange("Pm2Ffd", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm2Fee"
          label="PM2 Avgift SEK"
          value={client.Pm2Fee}
          onChange={(e) => handleInputChange("Pm2Fee", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="CollectionWaitCreate"
          label="Inkasso fördröjning dagar"
          value={client.CollectionWaitCreate}
          onChange={(e) =>
            handleInputChange("CollectionWaitCreate", e.target.value)
          }
          type="number"
          size="small"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
          <SelectWithClear
            name="DefaultAgreement"
            value={client?.DefaultAgreement}
            onChange={(e) =>
              handleInputChange("DefaultAgreement", e.target.value)
            }
            label="Förvald villkorskedja"
            disabled
          >
            {agreementOptions.map((options) => (
              <MenuItem key={options.Value} value={options.Value}>
                {options.Name}
              </MenuItem>
            ))}
          </SelectWithClear>
        </FormControl>
      </Grid>
    </Grid>
  );
}
